<script setup lang="ts">
interface DrugTestContent {
  pre_employment?: string
  random_testing?: string
  employee_experiences?: string
}

interface QuickFacts {
  Type?: string
}

interface Props {
  drugTestContent?: DrugTestContent
  quickFacts?: QuickFacts
}

const props = defineProps<Props>()
</script>

<template>
  <section class="bg-white mb-8">
    <div class="grid gap-8 md:grid-cols-2">
      <article class="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
        <h2 class="text-lg font-semibold mb-3">
          Pre-Employment Drug Testing
        </h2>
        <p class="text-slate-700">
          {{ drugTestContent?.pre_employment || 'Information not available.' }}
        </p>
      </article>

      <article class="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
        <h2 class="text-lg font-semibold mb-3">
          Random & Post-Accident Testing
        </h2>
        <p class="text-slate-700">
          {{ drugTestContent?.random_testing || 'Information not available.' }}
        </p>
      </article>

      <article class="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
        <h2 class="text-lg font-semibold mb-3">
          How Tests Are Conducted
        </h2>
        <ul class="list-disc pl-5 text-slate-700 space-y-1">
          <li>Typically a {{ quickFacts?.Type?.toLowerCase() || 'urine' }} test at an authorized clinic.</li>
          <li>Bring government ID and HR paperwork.</li>
          <li>Results are confidential and shared only with HR.</li>
        </ul>
      </article>

      <article class="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
        <h2 class="text-lg font-semibold mb-3">
          Employee Experiences
        </h2>
        <p class="text-slate-700">
          {{ drugTestContent?.employee_experiences || 'Experiences vary by role and location.' }}
        </p>
      </article>
    </div>
  </section>
</template>
